import React from 'react'
import Container from '../../Wrappers/Container'
import {fullName} from '../../../helpers/string-format'
import Badge from '../../Atoms/Badge'
import UserAvatar from '../../Atoms/Templates/UserAvatar'
import MainEmployeInformationItem from '../../Molecules/Items/MainEmployeInformationItem'
import InactiveTextButton from '../../Atoms/Buttons/DeleteTextButton'
import EditTextButton from '../../Atoms/Buttons/EditTextButton'

const EmployeesHeader = ({employee}) => {
  return (
    <Container className="employees-header flex nowrap lg-cols-2">
      <UserAvatar className="s-mr-32px flex-none" picture={employee.picture} />
      <div className="s-cross-start">
        <div className="flex-grow s-cross-center nowrap s-mb-12px">
          <div className="s-cross-center">
            <p className="t3 s-mb-0 s-mr-12px s-color-text">{fullName(employee)}</p>
            <Badge text="Vacaciones" />
          </div>

          <div className="s-main-end m-flex-gap-8px lg-flex-gap-4px s-to-right">
            <EditTextButton />
            <InactiveTextButton />
          </div>
        </div>

        <div className="flex s-flex-gap-16px lg-flex-gap-32px">
          <MainEmployeInformationItem
            icon="identification"
            title="No. identificación"
            text={employee.identification_number}
          />

          <MainEmployeInformationItem icon="user" title="Cargo" text="Diseñador UX" />

          <MainEmployeInformationItem icon="cash" title="Salario" text="3,000,000" />

          <MainEmployeInformationItem icon="clock" title="Horas" text="240" />
        </div>
      </div>
    </Container>
  )
}

export default EmployeesHeader
